import { render, staticRenderFns } from "./medicalcare.vue?vue&type=template&id=6380f612&scoped=true"
import script from "./medicalcare.vue?vue&type=script&lang=js"
export * from "./medicalcare.vue?vue&type=script&lang=js"
import style0 from "./medicalcare.vue?vue&type=style&index=0&id=6380f612&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6380f612",
  null
  
)

export default component.exports